import {
  SEND_ALERT,
  CLOSE_ALERT,
  ENABLE_LOADING,
  DISABLE_LOADING,
  SET_PERCENTAGE,
} from "../actions/alerts";

const init = { title: "", content: "", isAlertOpen: false, isLoading: false };

export default function alerts(
  state = init,
  action = { type: "", payload: {} }
) {
  if (action.payload) {
    var { title, content, percentage } = action.payload;
  }
  switch (action.type) {
    case SEND_ALERT:
      return { ...state, title, content, isAlertOpen: true };
    case CLOSE_ALERT:
      return { ...state, title: "", content: "", isAlertOpen: false };
    case ENABLE_LOADING:
      return { ...state, isLoading: true };
    case DISABLE_LOADING:
      return { ...state, isLoading: false };
    case SET_PERCENTAGE:
      return { ...state, percentage };
    default:
      return state;
  }
}
